import { triggerEvent } from 'utilities/dom';

import { schemes } from '../schemes';
import { getDefaultBoxTitleFromScheme } from '../utilities';

import getLayoutContentFromScheme from './getLayoutContentFromScheme';
import setPdpAnchorDynamically from './setPdpAnchorDynamically';
import renderLayoutContent from './renderLayoutContent';

function loadCertonaItems (widget, scheme, doNotReplaceExistingItems, boxTitle, widgets) {

	// Adding this check for covering the case if page is categorylanding but scheme is used as sortpage_rr
	if (
		$('.suggestedProductsContainer').filter(`[data-scheme="${scheme}_rr"]`).length === 0
		&& scheme === 'categorylanding'
		&& $('.suggestedProductsContainer').filter('[data-scheme="sortpage_rr"]').length > 0
	) {

		scheme = 'sortpage';

	}

	const recentlyViewedItemsRegex = /^GF_/i;
	const recentlyViewedHomePage = scheme.toLowerCase().search(schemes.GF_HOME) > -1;
	const justForYouHomePage = scheme.toLowerCase().search(schemes.LAST_CATEGORY) > -1;
	const moreLikeThisPage = scheme.toLowerCase().search(schemes.MORE_LIKE_THIS) > -1;
	const moreLikeThisModalCartPage = scheme.toLowerCase().search(schemes.SIMILARATC) > -1;
	const prWidgetHomepage = [ 'PRWidget1Homepage', 'PRWidget2Homepage', 'PRWidget3Homepage', 'PRWidget4Homepage' ]
		.find((id) => scheme.toLowerCase().includes(id.toLowerCase()));

	const recentScheme = recentlyViewedItemsRegex.test(scheme);
	const isLastCategoryScheme = /^lastCategory/i.test(scheme);
	const $suggestedProductsContainer = $('.suggestedProductsContainer').filter(`[data-scheme="${scheme}_rr"]`);

	const $container = recentScheme ? $('.recentlyViewedWrapper') : $suggestedProductsContainer;
	const isRelatedScheme = scheme === schemes.RELATED;
	const $anchorContainer = $('.sectionAnchors').find('[data-scheme="related_rr"]');
	const certonaTitleText = boxTitle || getDefaultBoxTitleFromScheme(scheme, boxTitle);
	const $certonaTitleSelector = recentScheme
		? $('.jsRecentlyViewedTitle')
		: $suggestedProductsContainer.find('.jsCertonaTitle');
	let layoutContent = getLayoutContentFromScheme(scheme, widget, widgets);

	// initialize certona title
	if (certonaTitleText) {

		$certonaTitleSelector.text(window.location.href.includes('/sfp/') && scheme === schemes.SIMILAR_2
			? 'Similar Items'
			: certonaTitleText);

		if ($suggestedProductsContainer) {

			const viewMorebtn = $suggestedProductsContainer.find('.moreViewButton');
			if (viewMorebtn) {

				viewMorebtn.removeClass('hidden');

			}

		}

	} else {

		// remove title if empty
		$certonaTitleSelector.remove();

	}

	if (doNotReplaceExistingItems && $('.pdRelItmsProdShadeOptions, .pdRelItmsProd').length > 0) {

		$container.addClass('loaded');
		if (isRelatedScheme) {

			$anchorContainer.removeClass('hidden');
			if (certonaTitleText) {

				setPdpAnchorDynamically({ $anchorContainer, certonaTitleText });

			}

		}

	} else {

		const isOfSort =			[
			'Chandeliers',
			'Lamp Shades',
			'outdoor decor',
			'home textiles',
			'landscape lighting',
			'ceiling medallions'
		].indexOf(window.resx.RecommendedItemsRequest.Criteria.Category) > -1;

		if (!layoutContent) {

			if (recentScheme) {

				$container.attr('data-scheme', `${scheme}_rr`);
				$container.attr('data-decisionId', widget?.DecisionId);

				layoutContent = getLayoutContentFromScheme(schemes.RECENTLY_VIEWED_ITEMS, widget);

			} else if (isOfSort) {

				layoutContent = getLayoutContentFromScheme(schemes.SORT_PAGE, widget);

			} else if (!isLastCategoryScheme) {

				layoutContent = getLayoutContentFromScheme(schemes.GENERIC_HORIZONTAL, widget);

			}

		}

		if (layoutContent) {

			if (recentlyViewedHomePage) {

				$('#recentlyViewedWidgetContainer').attr('data-decisionId', widget?.DecisionId);

				renderLayoutContent(scheme, layoutContent);

			} else if (recentScheme) {

				renderLayoutContent(schemes.RECENTLY_VIEWED_ITEMS, layoutContent);

			} else if (isOfSort) {

				$container.attr('data-decisionId', widget?.DecisionId);

				renderLayoutContent(scheme === schemes.CATEGORY_LANDING_02 ? scheme : schemes.SORT_PAGE, layoutContent);

			} else {

				if (justForYouHomePage) {

					$('#justForYouWidgetContainer').attr('data-decisionId', widget?.DecisionId);

				} else if (moreLikeThisPage) {

					$('.moreLikeThis').attr('data-decisionId', widget?.DecisionId);

				} else if (moreLikeThisModalCartPage) {

					$('#modalMoreYouMayLikeModal').attr('data-decisionId', widget?.DecisionId);

				} else if (prWidgetHomepage) {

					$(`#${prWidgetHomepage}`).attr('data-decisionId', widget?.DecisionId);

				} else {

					$container.attr('data-decisionId', widget?.DecisionId);

				}

				renderLayoutContent(scheme, layoutContent);

			}

		}

		if (isRelatedScheme) {

			$anchorContainer.removeClass('hidden');
			if (certonaTitleText) {

				setPdpAnchorDynamically({ $anchorContainer, certonaTitleText });

			}

		}
		$container.addClass('loaded');

		triggerEvent.call(document, `recommendedItems:${scheme}:loaded`);

		const recentItems = document.querySelector('.recentlyViewedWrapper .jsRecentlyViewedTitle');
		if (recentItems && recentItems.innerText === '') {

			$('.recentlyViewedWrapper>.group').remove();

		}

	}

}

export default loadCertonaItems;
